import { AlternativeDetailsDialogViewModel } from '@Alternatives/Alternatives/Components/AlternativeDetailsDialog';
import AlternativeDetailsDialog from "@Alternatives/Alternatives/Components/AlternativeDetailsDialog.vue";
import { AttributeDescriptionDialogViewModel } from '@Alternatives/Attributes/Components/AttributeDescriptionDialog';
import AttributeDescriptionDialog from '@Alternatives/Attributes/Components/AttributeDescriptionDialog.vue';
import { Refresh } from '@browser/Browser';
import * as rt from "@common/AppRT";
import { IEvaluationCommand } from '@Evaluation/cqrs';
import PanelistVoteEditor from '@Evaluation/Estimations/Components/PanelistVoteEditor.vue';
import VotesBrowser from '@Evaluation/Estimations/Components/VotesBrowser.vue';
import { SavePanelistCommentCommandV1, SavePanelistVoteCommandV1 } from '@Evaluation/Estimations/Domain/commands-core';
import EstimationsCommands from "@Evaluation/Estimations/Domain/commands-vue-component";
import EstimationsQueries from "@Evaluation/Estimations/Domain/queries-vue-component";
import { ActiveQuestionReadModel, PanelistMeetingPageReadModel, PanelistVoteReadModel } from '@Evaluation/Estimations/Domain/readmodels';
import { Component, mixins } from 'vue-facing-decorator';

@Component({
    components: {
        PanelistVoteEditor,
        VotesBrowser,
        AttributeDescriptionDialog,
        AlternativeDetailsDialog
    }
})
export default class PanelistMeetingPage extends mixins(EstimationsCommands, EstimationsQueries)
{
    get workspaceId() { return Number.parseInt(this.$route.params.workspaceId); }
    get surveyId(): number { return Number.parseInt(this.$route.params.surveyId); }
    get projectUserId(): number { return Number.parseInt(this.$route.params.projectUserId); }

    handler: any = null;

    Initialized: boolean = false;
    Connecting: boolean = true;

    MeetingStarted: boolean = false;
    EligibleQuestion: boolean = null;
    projectUserName: string = null;
    votes: PanelistVoteReadModel[] = null;
    Question: ActiveQuestionReadModel = null;
    DashboardUrl: string;
    AlternativesIds: number[] = [];

    AlternativeName: string = null;
    AttributeName: string = null;
    SavingCommentHandle: any = null;
    SavingValueHandle: any = null;

    voteValue: number | null = null;
    voteComment: string | null = null;

    attributeDescriptionDialog = new AttributeDescriptionDialogViewModel();
    alternativeDetailsDialog = new AlternativeDetailsDialogViewModel();

    //

    saveComment()
    {
        if (this.SavingCommentHandle == null)
        {
            this.SavingCommentHandle = setTimeout(() =>
            {
                this.handleSavePanelistCommentCommand(this.Question.QuestionId, this.voteComment);
                this.SavingCommentHandle = null;
            }, 1000);
        }
    }

    saveValue()
    {
        if (this.Question.HasScale)
        {
            this.handleSavePanelistVoteCommand(this.Question.QuestionId, this.voteValue, this.voteComment);
        }
        else
        {
            if (this.SavingValueHandle == null)
            {
                this.SavingValueHandle = setTimeout(() =>
                {
                    this.handleSavePanelistVoteCommand(this.Question.QuestionId, this.voteValue, this.voteComment);
                    this.SavingValueHandle = null;
                }, 1000);
            }
        }
    }

    //


    SetQuestion(question: ActiveQuestionReadModel)
    {
        this.Question = question;
        this.AlternativeName = question.AlternativeName;
        this.AttributeName = question.AttributeName;
        this.EligibleQuestion = this.AlternativesIds.indexOf(question.AlternativeId) > -1;

        if (this.EligibleQuestion)
        {
            const self = question.Entries?.find(a => a.ProjectUserId === this.projectUserId);

            if (self != null)
            {
                self.ProjectUserName = "Me";
            }

            this.loadVote();
        }
    }

    SetQuestionVotes(question: ActiveQuestionReadModel)
    {
        if (this.Question.QuestionId === question.QuestionId)
        {
            const self = question.Entries?.find(a => a.ProjectUserId === this.projectUserId) ?? null;

            if (self != null)
            {
                self.ProjectUserName = "Me";
            }

            this.Question.Entries = question.Entries;
        }
    }

    SetVotesBrowserEntry(entry: PanelistVoteReadModel)
    {
        if (this.Question.QuestionId === entry.QuestionId)
        {
            const current = this.Question.Entries.find(a => a.ProjectUserId === entry.ProjectUserId);
            current.Value = entry.Value;
            current.Comment = entry.Comment;
        }
    }


    ShowAlternativeDetailsCommand()
    {
        this.alternativeDetailsDialog.show(this.AlternativeName, this.Question.AlternativeDescription);
    }

    ShowAttributeDetailsCommand()
    {
        this.attributeDescriptionDialog.show(this.Question.AttributeName, this.Question.AttributeDescription);
    }


    loadVote()
    {
        this.runPanelistVoteQueryV1(this.workspaceId, this.projectUserId, this.Question.QuestionId);
    }


    handleUpdateComment(comment: string | null)
    {
        this.voteComment = comment;
        this.saveComment();
    }

    handleUpdateValue(value: number | null)
    {
        this.voteValue = value;
        this.saveValue();
    }


    handleSavePanelistVoteCommand(questionId: string, value: number, comment: string)
    {
        this.invokeSavePanelistVoteCommandV1(this.workspaceId, this.surveyId, this.projectUserId, questionId, value, comment);
    }

    handleSavePanelistCommentCommand(questionId: string, comment: string)
    {
        this.invokeSavePanelistCommentCommandV1(this.workspaceId, this.surveyId, this.projectUserId, questionId, comment);
    }


    mounted()
    {
        this.handler = rt.subscribeModule("Estimations.MeetingPanelist",
            {
                MeetingStopped: (data: any) =>
                {
                    if (this != null)
                    {
                        Refresh();
                    }
                },
                MeetingStarted: (data: ActiveQuestionReadModel) =>
                {
                    if (this.MeetingStarted === false)
                    {
                        this.Connecting = false;
                        this.MeetingStarted = true;
                        this.SetQuestion(data);
                    }
                },
                SetQuestion: (data: ActiveQuestionReadModel) =>
                {
                    if (this != null)
                    {
                        this.SetQuestion(data);
                    }
                },
                SetQuestionVotes: (data: ActiveQuestionReadModel) =>
                {
                    if (this != null)
                    {
                        this.SetQuestionVotes(data);
                    }
                },
                SetVoteEntry: (data: PanelistVoteReadModel) =>
                {
                    if (this != null)
                    {
                        this.SetVotesBrowserEntry(data);
                    }
                },
            });

        this.runPanelistMeetingPageQueryV1(this.workspaceId, this.surveyId, this.projectUserId);
    }

    onSetModel(model: any, modelName: string) 
    {
        if (modelName == "PanelistMeetingPageReadModel")
        {
            const rm = model as PanelistMeetingPageReadModel;
            this.projectUserName = rm.ProjectUserName;
            this.DashboardUrl = rm.DashboardUrl;
            this.AlternativesIds = rm.AlternativesIds;
            this.votes = rm.Votes;

            const handle = setTimeout(() =>
            {
                this.Connecting = false;
                clearTimeout(handle);
            }, 10000);

            this.requestMeetingStatus();
            this.Initialized = true;
        }
        else if (modelName === "PanelistVoteReadModel")
        {
            const vote = model as PanelistVoteReadModel;

            if (this.Question.QuestionId === vote.QuestionId)
            {
                this.voteValue = vote.Value;
                this.voteComment = vote.Comment;
            }
        }
    }

    onCommandSucceed(cmd: IEvaluationCommand, correlationId: string)
    {
        if (SavePanelistVoteCommandV1.matchType(cmd))
        {
            const questionId = correlationId;

            const cmd1 = cmd as SavePanelistVoteCommandV1;
            this.notifyVoteValueChanged(questionId, cmd1.Value);
        }
        else if (SavePanelistCommentCommandV1.matchType(cmd))
        {
            const questionId = correlationId;

            const cmd1 = cmd as SavePanelistCommentCommandV1;
            this.notifyVoteCommentChanged(questionId, cmd1.Comment);
        }
    }

    requestMeetingStatus()
    {
        rt.send("Estimations.MeetingPanelist", "RequestMeetingStatus",
            {
                WorkspaceId: this.workspaceId,
                SurveyId: this.surveyId,
                ProjectUserId: this.projectUserId,
            });
    }

    notifyVoteValueChanged(questionId: string, value: number | null)
    {
        rt.send("Estimations.MeetingPanelist", "NotifyVoteValueChanged",
            {
                WorkspaceId: this.workspaceId,
                SurveyId: this.surveyId,
                ProjectUserId: this.projectUserId,
                QuestionId: questionId,
                VoteValue: value
            });
    }

    notifyVoteCommentChanged(questionId: string, comment: string)
    {
        rt.send("Estimations.MeetingPanelist", "NotifyVoteCommentChanged",
            {
                WorkspaceId: this.workspaceId,
                SurveyId: this.surveyId,
                ProjectUserId: this.projectUserId,
                QuestionId: questionId,
                Comment: comment
            });
    }

    beforeDestroy()
    {
        if (this.handler)
        {
            rt.unsubscribe(this.handler);
        }
    }
}